// extracted by mini-css-extract-plugin
module.exports = {"container":"favoriteList__container___3F7MA"};